import { render, staticRenderFns } from "./UserInventory.vue?vue&type=template&id=3443a845&scoped=true&"
import script from "./UserInventory.vue?vue&type=script&lang=js&"
export * from "./UserInventory.vue?vue&type=script&lang=js&"
import style0 from "./UserInventory.vue?vue&type=style&index=0&id=3443a845&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3443a845",
  null
  
)

export default component.exports